import PropTypes from 'prop-types'
import React from 'react'

import ListItemIcon from '@material-ui/core/ListItemIcon'

import {
  AttachFile,
  AttachMoney,
  CheckCircle,
  ConfirmationNumber,
  Dashboard,
  Description,
  GroupWork,
  Language,
  Notifications,
  Person,
  Place,
  QueryBuilder,
  SettingsCell,
  Star,
  Subscriptions
} from '@material-ui/icons'

const checkIcon = menuName => {
  switch (menuName) {
    case 'Clipping':
      return <AttachFile />

    case 'Notificações':
      return <Notifications />

    case 'Parceiros':
      return <GroupWork />

    case 'Eventos':
      return <Language />

    case 'Roteiros':
      return <Subscriptions />

    case 'Usuários':
      return <Person />

    case 'Momentos':
      return <QueryBuilder />

    case 'Validador':
      return <CheckCircle />

    case 'Relatório de Vendas':
      return <Description />

    case 'Cortesias':
      return <ConfirmationNumber />

    case 'Unidades':
      return <Place />

    case 'Desafios':
      return <Star />

    case 'Temas do App':
      return <SettingsCell />

    case 'Mural':
      return <Description />

    case 'Pagamentos':
      return <AttachMoney />

    default:
      return <Dashboard />
  }
}

function SideBarIcon({ menuName, className }) {
  return <ListItemIcon className={className || ''}>{checkIcon(menuName)}</ListItemIcon>
}

SideBarIcon.propTypes = {
  menuName: PropTypes.string.isRequired
}

export default SideBarIcon
